import type { Variable } from '../../types';
import type { Transform } from 'mdast-util-from-markdown';
import type { MdxJsxTextElement } from 'mdast-util-mdx-jsx';

import { visit } from 'unist-util-visit';

import { NodeTypes } from '../../enums';

const variables =
  ({ asMdx } = { asMdx: true }): Transform =>
  tree => {
    visit(tree, (node, index, parent) => {
      if (!['mdxFlowExpression', 'mdxTextExpression'].includes(node.type) || !('value' in node)) return;

      // @ts-expect-error - estree is not defined on our mdx types?!
      if (node.data.estree.type !== 'Program') return;
      // @ts-expect-error - estree is not defined on our mdx types?!
      const [expression] = node.data.estree.body;
      if (
        !expression ||
        expression.type !== 'ExpressionStatement' ||
        expression.expression.object?.name !== 'user' ||
        !['Literal', 'Identifier'].includes(expression.expression.property?.type)
      )
        return;

      const name =
        expression.expression.property.type === 'Identifier'
          ? expression.expression.property.name
          : expression.expression.property.value;

      const position = 'position' in node ? node.position : undefined;
      const variable = asMdx
        ? ({
            type: 'mdxJsxTextElement',
            name: 'Variable',
            attributes: [
              {
                type: 'mdxJsxAttribute',
                name: 'name',
                value: name,
              },
            ],
            children: [],
            position,
          } as MdxJsxTextElement)
        : ({
            type: NodeTypes.variable,
            data: {
              hName: 'Variable',
              hProperties: {
                name,
              },
            },
            value: `{${node.value}}`,
            position,
          } as Variable);

      parent.children.splice(index, 1, variable);
    });

    return tree;
  };

export default variables;
